import styled from 'styled-components/macro';

import { sizes } from '../../styles/vars';

const Content = styled.div`
  display: flex;
  justify-content: center;
  width: calc(100% - ${sizes.orderWidth} - ${sizes.controlsWidth});
  padding: ${sizes.blockPaddingY} ${sizes.blockPaddingX} ${sizes.blockPaddingY} 0;
`;

export default Content;
